// Nation Personality Quiz — fully editable.
// Update prompts, answers, scoring, or result copy without touching components.

// =============================================================
// QUESTIONS — each answer awards points to one or more nations.
// =============================================================
export const QUESTIONS = [
  {
    id: "q1",
    prompt: "A stranger insults you in front of a crowd. What do you do?",
    answers: [
      { id: "a", text: "Laugh it off — then make sure everyone remembers who looked better.", scores: { arathia: 2 } },
      { id: "b", text: "Tell them the truth so directly the room goes silent.", scores: { verdani: 2 } },
      { id: "c", text: "Say nothing. Remember everything. Decide later if they matter.", scores: { namtaria: 2, akira: 1 } },
      { id: "d", text: "Step closer and make them regret choosing you.", scores: { theraka: 2 } },
      { id: "e", text: "Turn the crowd itself against them with a better story.", scores: { zar: 2, specula: 1 } },
      { id: "f", text: "Analyze why they did it. What it reveals matters more than the insult.", scores: { khepera: 2, abyssari: 1 } },
    ],
  },
  {
    id: "q2",
    prompt: "A friend is spiraling emotionally. What is your instinct?",
    answers: [
      { id: "a", text: "Sit beside them quietly until they can breathe again.", scores: { namtaria: 2, abyssari: 1 } },
      { id: "b", text: "Tell them the hard truth — lying would insult them.", scores: { verdani: 2 } },
      { id: "c", text: "Distract them, hype them up, remind them they're iconic.", scores: { arathia: 1, specula: 2 } },
      { id: "d", text: "Protect them physically — remove whatever's hurting them.", scores: { theraka: 2, akira: 1 } },
      { id: "e", text: "Build a plan to fix the entire situation.", scores: { zar: 2, khepera: 1 } },
    ],
  },
  {
    id: "q3",
    prompt: "What kind of power tempts you most?",
    answers: [
      { id: "a", text: "The power to be admired.", scores: { arathia: 2, specula: 1 } },
      { id: "b", text: "The power to survive anything.", scores: { akira: 2, theraka: 1 } },
      { id: "c", text: "The power to know what others cannot.", scores: { khepera: 2, abyssari: 1 } },
      { id: "d", text: "The power to control outcomes.", scores: { zar: 3 } },
      { id: "e", text: "The power to stay calm when others break.", scores: { namtaria: 3 } },
      { id: "f", text: "The power to protect what is real.", scores: { verdani: 3 } },
    ],
  },
  {
    id: "q4",
    prompt: "Pick the insult that would actually annoy you most.",
    answers: [
      { id: "a", text: "\"You're weak.\"", scores: { arathia: 2, theraka: 1 } },
      { id: "b", text: "\"You're fake.\"", scores: { verdani: 2, specula: 1 } },
      { id: "c", text: "\"You're emotional.\"", scores: { namtaria: 3 } },
      { id: "d", text: "\"You're naive.\"", scores: { abyssari: 2, zar: 1 } },
      { id: "e", text: "\"You don't understand.\"", scores: { khepera: 3 } },
      { id: "f", text: "\"You need people.\"", scores: { akira: 3 } },
    ],
  },
  {
    id: "q5",
    prompt: "You find an ancient forbidden book. What do you do?",
    answers: [
      { id: "a", text: "Read it immediately. Obviously.", scores: { khepera: 3 } },
      { id: "b", text: "Ask who sealed it and why before touching it.", scores: { abyssari: 2, khepera: 1 } },
      { id: "c", text: "Use it — if it protects my people.", scores: { verdani: 2, specula: 1 } },
      { id: "d", text: "Hide it until I understand how to benefit from it.", scores: { zar: 2 } },
      { id: "e", text: "Destroy it if it smells like chains.", scores: { akira: 2 } },
      { id: "f", text: "Sell tickets to the dramatic opening ceremony.", scores: { arathia: 2 } },
      { id: "g", text: "Use it as bait. See who comes hunting.", scores: { theraka: 1, namtaria: 2 } },
    ],
  },
  {
    id: "q6",
    prompt: "What makes you trust someone?",
    answers: [
      { id: "a", text: "Consistency under pressure.", scores: { namtaria: 2, abyssari: 1 } },
      { id: "b", text: "They tell the truth even when it costs them.", scores: { verdani: 3 } },
      { id: "c", text: "They survive something ugly and keep standing.", scores: { akira: 3 } },
      { id: "d", text: "They prove strength through action, not words.", scores: { theraka: 2, arathia: 1 } },
      { id: "e", text: "They protect the group, not just themselves.", scores: { specula: 3 } },
      { id: "f", text: "They think three steps ahead.", scores: { zar: 2, khepera: 1 } },
    ],
  },
  {
    id: "q7",
    prompt: "Which place feels most like home?",
    answers: [
      { id: "a", text: "A living forest that knows when you lie.", scores: { verdani: 3 } },
      { id: "b", text: "A golden city of arenas, music, and glory.", scores: { arathia: 3 } },
      { id: "c", text: "A silent temple where demons whisper from sealed orbs.", scores: { namtaria: 3 } },
      { id: "d", text: "A mirror-lit mountain city where heroes are remembered forever.", scores: { specula: 3 } },
      { id: "e", text: "A wild jungle where only the strong move freely.", scores: { theraka: 3 } },
      { id: "f", text: "A hidden abyssal city beneath crushing water.", scores: { abyssari: 3 } },
      { id: "g", text: "A sky palace above the world.", scores: { zar: 3 } },
      { id: "h", text: "A library older than your bloodline.", scores: { khepera: 3 } },
      { id: "i", text: "A ruined road where no one can claim you.", scores: { akira: 3 } },
    ],
  },
  {
    id: "q8",
    prompt: "Your greatest flaw is probably…",
    answers: [
      { id: "a", text: "I overthink until the future becomes a monster.", scores: { abyssari: 3 } },
      { id: "b", text: "I chase perfection and hate being seen as less.", scores: { arathia: 3 } },
      { id: "c", text: "I can be too blunt for my own good.", scores: { verdani: 3 } },
      { id: "d", text: "I detach when feelings get inconvenient.", scores: { namtaria: 3 } },
      { id: "e", text: "I do not trust easily — sometimes not at all.", scores: { akira: 3 } },
      { id: "f", text: "I need to win, or at least dominate the room.", scores: { theraka: 3 } },
      { id: "g", text: "I care too much about how I am seen.", scores: { specula: 3 } },
      { id: "h", text: "I believe I know best. Often, I do.", scores: { zar: 3 } },
      { id: "i", text: "I ask questions that probably should not be asked.", scores: { khepera: 3 } },
    ],
  },
  {
    id: "q9",
    prompt: "In a group project, you naturally become…",
    answers: [
      { id: "a", text: "The researcher with too many notes.", scores: { khepera: 3 } },
      { id: "b", text: "The leader quietly deciding the real plan.", scores: { zar: 3 } },
      { id: "c", text: "The honest one fixing everyone's nonsense.", scores: { verdani: 3 } },
      { id: "d", text: "The face of the project.", scores: { arathia: 2, specula: 1 } },
      { id: "e", text: "The security system with legs.", scores: { theraka: 2, akira: 1 } },
      { id: "f", text: "The calm one managing disaster.", scores: { namtaria: 3 } },
      { id: "g", text: "The one asking, \"What happens if this goes horribly wrong?\"", scores: { abyssari: 3 } },
    ],
  },
  {
    id: "q10",
    prompt: "Pick a personal motto.",
    answers: [
      { id: "a", text: "\"Truth does not need decoration.\"", scores: { verdani: 3 } },
      { id: "b", text: "\"If I bleed, I decide why.\"", scores: { akira: 3 } },
      { id: "c", text: "\"Become undeniable.\"", scores: { arathia: 3 } },
      { id: "d", text: "\"Control is mercy.\"", scores: { namtaria: 3 } },
      { id: "e", text: "\"To be remembered is to survive.\"", scores: { specula: 3 } },
      { id: "f", text: "\"Instinct never lies.\"", scores: { theraka: 3 } },
      { id: "g", text: "\"The future always leaves a warning.\"", scores: { abyssari: 3 } },
      { id: "h", text: "\"Order belongs to those brave enough to shape it.\"", scores: { zar: 3 } },
      { id: "i", text: "\"Knowledge is a door, even when it has teeth.\"", scores: { khepera: 3 } },
    ],
  },
  {
    id: "q11",
    prompt: "Someone gives you authority. What do you do with it?",
    answers: [
      { id: "a", text: "Build a system that works whether people like it or not.", scores: { zar: 3 } },
      { id: "b", text: "Protect the group and become the symbol they need.", scores: { specula: 3 } },
      { id: "c", text: "Set clear expectations and punish laziness.", scores: { namtaria: 3 } },
      { id: "d", text: "Make sure everyone tells the truth and pulls weight.", scores: { verdani: 3 } },
      { id: "e", text: "Use it to prove I deserved it.", scores: { arathia: 3 } },
      { id: "f", text: "Keep everyone alive — even if they hate my choices.", scores: { abyssari: 3 } },
      { id: "g", text: "Refuse the leash unless I chose the mission.", scores: { akira: 2, theraka: 2 } },
      { id: "h", text: "Research every precedent before writing one rule.", scores: { khepera: 3 } },
    ],
  },
  {
    id: "q12",
    prompt: "What do you secretly want most?",
    answers: [
      { id: "a", text: "Peace from the past.", scores: { akira: 3 } },
      { id: "b", text: "Recognition.", scores: { arathia: 2, specula: 1 } },
      { id: "c", text: "Freedom.", scores: { theraka: 3 } },
      { id: "d", text: "Certainty.", scores: { abyssari: 3 } },
      { id: "e", text: "Mastery.", scores: { namtaria: 3 } },
      { id: "f", text: "Truth.", scores: { verdani: 3 } },
      { id: "g", text: "Understanding.", scores: { khepera: 3 } },
      { id: "h", text: "Control.", scores: { zar: 3 } },
    ],
  },
  {
    id: "q13",
    prompt: "A door appears in the woods. It glows. No one else can see it.",
    answers: [
      { id: "a", text: "Walk through. Obviously.", scores: { khepera: 2, theraka: 1 } },
      { id: "b", text: "Mark it. Document it. Come back with witnesses.", scores: { khepera: 1, abyssari: 2 } },
      { id: "c", text: "Burn a sigil into it. It does not get to choose me.", scores: { akira: 2, namtaria: 1 } },
      { id: "d", text: "Ignore it. Whatever wants me will have to come find me.", scores: { verdani: 2 } },
      { id: "e", text: "Open it dramatically. Pose.", scores: { arathia: 2, specula: 1 } },
      { id: "f", text: "Memorize its location. I'll return when I rule something.", scores: { zar: 3 } },
      { id: "g", text: "Walk past, smiling. The door is the trap.", scores: { abyssari: 2, namtaria: 1 } },
    ],
  },
  {
    id: "q14",
    prompt: "Pick your worst nightmare.",
    answers: [
      { id: "a", text: "Being forgotten.", scores: { specula: 2, arathia: 1 } },
      { id: "b", text: "Being controlled.", scores: { akira: 2, theraka: 1 } },
      { id: "c", text: "Being wrong.", scores: { khepera: 2, zar: 1 } },
      { id: "d", text: "Being seen the moment I break.", scores: { namtaria: 2, arathia: 1 } },
      { id: "e", text: "Being naive — the danger I never saw.", scores: { abyssari: 3 } },
      { id: "f", text: "Being lied to without knowing.", scores: { verdani: 3 } },
    ],
  },
  {
    id: "q15",
    prompt: "A child asks: what is the most important thing in the world?",
    answers: [
      { id: "a", text: "\"Telling the truth, even when it hurts.\"", scores: { verdani: 3 } },
      { id: "b", text: "\"Knowing who to trust. And how to fight.\"", scores: { akira: 3 } },
      { id: "c", text: "\"Becoming someone people remember.\"", scores: { arathia: 2, specula: 1 } },
      { id: "d", text: "\"Staying calm when everyone else loses it.\"", scores: { namtaria: 3 } },
      { id: "e", text: "\"Being part of something bigger than yourself.\"", scores: { specula: 3 } },
      { id: "f", text: "\"Living loudly enough that the world hears you.\"", scores: { theraka: 3 } },
      { id: "g", text: "\"Listening to the quiet part of the room.\"", scores: { abyssari: 3 } },
      { id: "h", text: "\"Understanding the rules — then choosing which to keep.\"", scores: { zar: 3 } },
      { id: "i", text: "\"Curiosity. Always curiosity.\"", scores: { khepera: 3 } },
    ],
  },
];

// =============================================================
// RESULTS — one per nation. Edit copy freely.
// =============================================================
export const RESULTS = {
  verdani: {
    slug: "verdani",
    nation: "Verdani",
    title: "The Greenborn",
    hook: "Truth claimed you before comfort could.",
    description:
      "You belong to Verdani — the nation of roots, sunlight, blunt honesty, and stubborn loyalty. You are grounded, protective, and allergic to fake behavior. You do not need performance when reality is already loud enough. People may call you harsh, but your honesty usually comes from care. You would rather deal with the uncomfortable truth than live inside a beautiful lie.",
    strengths: ["Honest", "Reliable", "Protective", "Practical", "Loyal", "Resilient"],
    shadow:
      "You can be too blunt, too stubborn, and too quick to dismiss emotions that don't look useful.",
    friendRole: "You are the friend who says what everyone else is avoiding.",
    firstCharacter: "Selura",
    accent: "#4A7C3A",
    image: "/art/nation_verdani.jpg",
    symbol: "/art/symbol_verdani.jpg",
  },
  akira: {
    slug: "akira",
    nation: "Akira",
    title: "The Blood-Touched",
    hook: "Your scars did not soften you. They sharpened you.",
    description:
      "You belong to Akira — the scattered nation of blood, survival, exile, and hard-earned trust. You feel deeply, but you do not hand people the knife and ask them to be gentle. Your loyalty is rare because it costs something. You may seem distant, intense, or guarded, but beneath that armor is someone who remembers every betrayal and every kindness.",
    strengths: ["Resilient", "Perceptive", "Loyal when earned", "Independent", "Intense", "Protective"],
    shadow: "You can mistake isolation for safety and survival for identity.",
    friendRole: "You are the friend who acts like they don't care, then protects everyone anyway.",
    firstCharacter: "Shion",
    accent: "#A8323A",
    image: "/art/nation_akira.jpg",
    symbol: "/art/symbol_akira.jpg",
  },
  arathia: {
    slug: "arathia",
    nation: "Arathia",
    title: "The People of Apollo",
    hook: "Greatness did not call softly. It demanded a stage.",
    description:
      "You belong to Arathia — the nation of strength, beauty, discipline, performance, and glory. You believe people should strive to become more than ordinary. Whether through body, talent, style, art, or ambition, you understand the power of being seen at your best. You chase excellence because mediocrity feels like decay.",
    strengths: ["Ambitious", "Charismatic", "Disciplined", "Expressive", "Inspiring", "Competitive"],
    shadow: "You can tie your worth too tightly to appearance, achievement, or applause.",
    friendRole: "You are the friend who turns self-improvement into a dramatic event.",
    firstCharacter: "Dorion",
    accent: "#D4AF68",
    image: "/art/nation_arathia.jpg",
    symbol: "/art/symbol_arathia.jpg",
  },
  namtaria: {
    slug: "namtaria",
    nation: "Namtaria",
    title: "Children of Namtar",
    hook: "You do not fear darkness. You organize it.",
    description:
      "You belong to Namtaria — the nation of discipline, restraint, demon-binding, ritual, and emotional control. You don't panic easily. You prefer efficiency over chaos and truth over comfort. Where others collapse into feelings, you step back, observe, and choose the cleanest path forward. Your calm can be intimidating — but it is also your blade.",
    strengths: ["Disciplined", "Composed", "Strategic", "Efficient", "Honest", "Hard to shake"],
    shadow: "You can detach too much and confuse emotional distance with strength.",
    friendRole: "You are the friend who stays calm while everyone else catches fire.",
    firstCharacter: "Seraphi",
    accent: "#B33A8C",
    image: "/art/nation_namtaria.jpg",
    symbol: "/art/symbol_namtaria.jpg",
  },
  specula: {
    slug: "specula",
    nation: "Specula",
    title: "The Mirror Nation",
    hook: "You were built to shine where others look away.",
    description:
      "You belong to Specula — the nation of mirrors, sacrifice, public identity, heroism, and social gravity. You understand people are shaped by how the world sees them. You want to matter, to belong, to stand for something larger than yourself. At your best, you inspire. At your worst, you lose yourself in the reflection.",
    strengths: ["Socially aware", "Stylish", "Heroic", "Loyal to causes", "Adaptable", "Memorable"],
    shadow: "You can become dependent on recognition and forget who you are without an audience.",
    friendRole: "You are the friend who knows the vibe, the stakes, and the social consequences.",
    firstCharacter: "Lyssandra",
    accent: "#9EA9B4",
    image: "/art/nation_specula.jpg",
    symbol: "/art/symbol_specula.jpg",
  },
  theraka: {
    slug: "theraka",
    nation: "Theraka",
    title: "The Beast-Clans",
    hook: "The cage was never going to hold you.",
    description:
      "You belong to Theraka — the nation of instinct, appetite, dominance, wilderness, and survival. You trust action more than theory and freedom more than approval. You want to live loudly, move freely, protect your pack, and prove strength through presence. You are not built for cages, soft rules, or people who confuse politeness with loyalty.",
    strengths: ["Bold", "Instinctive", "Protective", "Physical", "Passionate", "Fearless"],
    shadow: "You can confuse dominance with purpose and freedom with impulse.",
    friendRole: "You are the friend who says \"we'll figure it out\" while already climbing the fence.",
    firstCharacter: "Dravos",
    accent: "#7C2C2C",
    image: "/art/nation_theraka.jpg",
    symbol: "/art/symbol_theraka.jpg",
  },
  abyssari: {
    slug: "abyssari",
    nation: "Abyssari",
    title: "The Deep Ones",
    hook: "You heard the warning before the wave arrived.",
    description:
      "You belong to Abyssari — the hidden nation of gravity, prophecy, deep water, caution, and unseen consequences. You notice what others miss. You sense when something is wrong before there is proof. People may call you paranoid, but they usually come back later asking how you knew.",
    strengths: ["Intuitive", "Cautious", "Strategic", "Emotionally deep", "Loyal", "Observant"],
    shadow: "You can overprepare for storms that never arrive and mistake fear for foresight.",
    friendRole: "You are the friend who checks the exits before sitting down.",
    firstCharacter: "Bahram",
    accent: "#6F4FB5",
    image: "/art/nation_abyssari.jpg",
    symbol: "/art/symbol_abyssari.jpg",
  },
  zar: {
    slug: "zar",
    nation: "Zar",
    title: "The Sky Lords",
    hook: "You were not born to follow the board. You were born to move the pieces.",
    description:
      "You belong to Zar — the nation of sky citadels, elegance, strategy, control, and dangerous certainty. You naturally see systems, leverage, and hierarchy. You believe order does not appear by accident — someone has to shape it. You can be visionary, persuasive, and commanding, but your greatest danger is believing your plan matters more than people.",
    strengths: ["Strategic", "Confident", "Persuasive", "Visionary", "Organized", "Influential"],
    shadow: "You can become self-righteous, controlling, and convinced your superiority excuses the cost.",
    friendRole: "You are the friend who somehow becomes the group's unofficial manager.",
    firstCharacter: "Kaelen",
    accent: "#3B6BA8",
    image: "/art/nation_zar.jpg",
    symbol: "/art/symbol_zar.jpg",
  },
  khepera: {
    slug: "khepera",
    nation: "Khepera",
    title: "Children of the Sacred Birds",
    hook: "The question found you, and now you cannot leave it alone.",
    description:
      "You belong to Khepera — the nation of scholars, bird-folk, libraries, glyphs, healing, and dangerous curiosity. You seek understanding before action, but once your curiosity catches fire, common sense may lose the argument. You believe knowledge is sacred, mysteries are invitations, and old texts are probably only cursed because nobody translated them correctly.",
    strengths: ["Curious", "Intelligent", "Analytical", "Imaginative", "Helpful", "Truth-seeking"],
    shadow: "You can overthink, overexplain, and chase answers past the point of safety.",
    friendRole: "You are the friend who says \"I researched it\" and then reveals something terrifying.",
    firstCharacter: "Thamir",
    accent: "#C5A059",
    image: "/art/nation_khepera.jpg",
    symbol: "/art/symbol_khepera.jpg",
  },
};

export const NATION_ORDER = [
  "verdani", "akira", "arathia", "namtaria", "specula",
  "theraka", "abyssari", "zar", "khepera",
];

// =============================================================
// Scoring + tie-break logic
// =============================================================
export function tallyScores(selections) {
  // selections: [{ qid, aid, scores: {nation: pts} }]
  const totals = {};
  const primaries = {}; // count of answers where this nation had the highest score in the answer
  NATION_ORDER.forEach((n) => {
    totals[n] = 0;
    primaries[n] = 0;
  });

  for (const s of selections) {
    if (!s?.scores) continue;
    const entries = Object.entries(s.scores);
    if (!entries.length) continue;
    const max = Math.max(...entries.map(([, v]) => v));
    for (const [nation, pts] of entries) {
      totals[nation] = (totals[nation] || 0) + pts;
      if (pts === max) primaries[nation] = (primaries[nation] || 0) + 1;
    }
  }

  // Find highest total
  const topScore = Math.max(...Object.values(totals));
  const leaders = NATION_ORDER.filter((n) => totals[n] === topScore && topScore > 0);

  if (leaders.length === 1) {
    return { primary: leaders[0], hybrid: null, totals, primaries };
  }

  // Tie-break 1: most primary answers
  const topPrim = Math.max(...leaders.map((n) => primaries[n]));
  const primLeaders = leaders.filter((n) => primaries[n] === topPrim);
  if (primLeaders.length === 1) {
    return { primary: primLeaders[0], hybrid: null, totals, primaries };
  }

  // Tie-break 2: hybrid result of top two
  return {
    primary: primLeaders[0],
    hybrid: primLeaders[1] || leaders[1],
    totals,
    primaries,
  };
}

// =============================================================
// Claimed-nation persistence (used by Archive page for personalization)
// =============================================================
const CLAIMED_KEY = "cbb-claimed-nation";

export function setClaimedNation(slug) {
  try {
    if (typeof window !== "undefined" && slug) {
      localStorage.setItem(CLAIMED_KEY, slug);
    }
  } catch (e) { /* no-op */ }
}

export function getClaimedNation() {
  try {
    if (typeof window !== "undefined") {
      return localStorage.getItem(CLAIMED_KEY) || "";
    }
  } catch (e) { /* no-op */ }
  return "";
}

// =============================================================
// Analytics dispatch — integration-ready custom events
// =============================================================
export function track(event, detail = {}) {
  try {
    if (typeof window !== "undefined") {
      window.dispatchEvent(
        new CustomEvent("cbb-analytics", { detail: { event, ...detail } })
      );
      // also log for now (replace with provider later)
      // eslint-disable-next-line no-console
      console.info("[cbb-analytics]", event, detail);
    }
  } catch (e) {
    // no-op
  }
}
